import type { SVGProps } from 'react';

export const SvgIconCategory150 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.625 16.625C9.45343 16.625 10.125 15.9534 10.125 15.125C10.125 14.2966 9.45343 13.625 8.625 13.625C7.79657 13.625 7.125 14.2966 7.125 15.125C7.125 15.9534 7.79657 16.625 8.625 16.625Z"
      fill="black"
    />
    <path
      d="M8.625 25.125C11.3864 25.125 13.625 20.6478 13.625 15.125C13.625 9.60215 11.3864 5.125 8.625 5.125C5.86358 5.125 3.625 9.60215 3.625 15.125C3.625 20.6478 5.86358 25.125 8.625 25.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.625 15.125V26.125C13.625 26.3902 13.7304 26.6446 13.9179 26.8321C14.1054 27.0196 14.3598 27.125 14.625 27.125H28.625C28.8902 27.125 29.1446 27.0196 29.3321 26.8321C29.5196 26.6446 29.625 26.3902 29.625 26.125V15.125C29.625 9.6 27.3875 5.125 24.625 5.125H8.625"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.625 15.125H16.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.625 15.125H22.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M26.625 15.125H29.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
